import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Form } from '@dex/bubl-dash/src/lib/functions/useForm';
import Line from '@dex/bubl-dash/src/lib/components/Line/Line';
import Button, { ButtonRow } from '@dex/bubl-dash/src/lib/components/Button/Button';
import FieldSwitch from '@dex/bubl-dash/src/lib/components/Fields/FieldSwitch';
import FieldText from '@dex/bubl-dash/src/lib/components/Fields/FieldText';


const HelpTopicCreateEditForm: React.FC<any> = (props: any) => {

    const { form, process, handleSubmit } = props;

    // eslint-disable-next-line
    let data = props.data || {};

    return useMemo(() => (

        <Panel
            heading={"Help Topic Details"}
        >

            <Form
                form={form}
                onSubmit={handleSubmit}
                loading={process.loading}
            >

                <Row gutter={8} edge={true}>

                    <Row gutter={8} edge={true}>

                        <Col col={{ xs: 24, md: 8 }}>

                            <FieldText
                                form={form}
                                label="Title"
                                name="title"
                                required={true}
                                defaultValue={form.defaults.title}
                            />

                        </Col>

                        <Col col={{ xs: 24, md: 8 }}>

                            <FieldSwitch
                                form={form}
                                label="Show To Hosts"
                                name="showHosts"
                                defaultValue={form.defaults.showHosts}
                            />

                        </Col>

                        <Col col={{ xs: 24, md: 8 }}>

                            <FieldSwitch
                                form={form}
                                label="Show On Dashboard"
                                name="showDashboard"
                                defaultValue={form.defaults.showDashboard}
                            />


                        </Col>

                    </Row>

                </Row>

                <Line />

                <ButtonRow>
                    <Button
                        label={"Submit"}
                        loading={process.loading}
                    />
                    <Button
                        label={"Reset"}
                        type={"faded"}
                        onClick={form.reset}
                    />
                </ButtonRow>

            </Form>

        </Panel>


    ), [props]);

}

export default HelpTopicCreateEditForm;
